export default {
    title: 'MyFreeCams - The #1 adult webcam community!',
    description:
        'MyFreeCams is the original free webcam community for adults, featuring live video chat with thousands of models, cam girls, amateurs and female content creators!',
}
